import SettingConfig from '@module/config/setting';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { aspCond } from '@module/helpers/conditions/condition';
import { cn } from '@module/lib/utils';
import useChatPanelStore from '@module/stores/useChatPanelStore';
import useModalStore from '@module/stores/useModalStore';

function LoginIntro() {
  const { isLogin } = useGetLoginInfoQuery();
  const { pushModal } = useModalStore((state) => state);
  const pcFontSize = useChatPanelStore((state) => state.pcFontSize);

  const fontSizeClass = {
    'text-[13px]': pcFontSize === 13,
    'text-[15px]': pcFontSize === 15,
    'text-[19px]': pcFontSize === 19,
  };
  return (
    <div className={cn('mb-[3px] text-center', fontSizeClass)}>
      <p className='text-left text-baseFg'>방송시청을 위하여 로그인이 필요합니다.</p>
      <button
        type='button'
        className='my-[15px] whitespace-pre-wrap rounded-[10px] bg-colorBg13 px-[17px] py-2 text-[13px] text-colorFg12'
        onClick={(e) => {
          if (isLogin) return;
          e.stopPropagation();
          if (aspCond.if('new-asp')) {
            SettingConfig.aspUtils?.goLogin();
            return;
          }
          pushModal({ type: 'AUTH_MODAL', id: 'LoginIntro' });
        }}
      >
        {'로그인하기'}
      </button>
    </div>
  );
}

export default LoginIntro;
